import React, { useState } from 'react'
import './LanguagePickerModal.scss'
import { languagesData } from '@core/utils/helpers/languagesData'
import { EarthIcon } from './icons/earth_icon'
import { SearchIcon } from './icons/searchicon'
import { RepeatIcon } from './icons/repeat_icon'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
  onSelect: (languageId: number) => void
  excludeIds?: number[]
}

const LanguagePickerModal: React.FC<Props> = ({ onClose, onSelect, excludeIds = [] }) => {
  const { t } = useTranslation()

  const [search, setSearch] = useState('')
  const normalizedSearch = search.trim().toLowerCase()

  const availableLanguages = Object.values(languagesData).filter(
    (l) => l && !excludeIds.includes(l.languageId)
  )

  const filteredLanguages = normalizedSearch
    ? availableLanguages.filter((l) => l.name.toLowerCase().includes(normalizedSearch))
    : availableLanguages

  const allLanguages =
    normalizedSearch.length > 0
      ? [
          ...filteredLanguages.filter((l) => l.name.toLowerCase().startsWith(normalizedSearch)),
          ...filteredLanguages.filter((l) => !l.name.toLowerCase().startsWith(normalizedSearch)),
        ]
      : filteredLanguages

  return (
    <div className="language-modal-backdrop">

      <div className="language-modal">
        <div className="language-modal-header">
          <span>{t('10605', 'Add language')}</span>
          <button onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6239 2.19526C13.8843 2.45561 13.8843 2.87772 13.6239 3.13807L8.8524 7.90963L13.8047 12.8619C14.0651 13.1223 14.0651 13.5444 13.8047 13.8047C13.5444 14.0651 13.1223 14.0651 12.8619 13.8047L7.90959 8.85243L3.13807 13.6239C2.87772 13.8843 2.45561 13.8843 2.19526 13.6239C1.93491 13.3636 1.93491 12.9415 2.19526 12.6811L6.96678 7.90963L2.37605 3.31886C2.1157 3.05851 2.11571 2.6364 2.37606 2.37605C2.63641 2.11571 3.05852 2.11571 3.31887 2.37606L7.90959 6.96682L12.6811 2.19526C12.9415 1.93491 13.3636 1.93491 13.6239 2.19526Z" fill="#19191A" />
            </svg>

          </button>
        </div>
        <div className="language-search">
          <div className="input-wrapper">
            <div className="search-icon">
              <SearchIcon />
            </div>
            <input
              type="text"
              placeholder={t('61', 'Search') + '...'}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search && (
              <button
                className="clear-btn"
                onClick={() => setSearch('')}
                aria-label="Clear search"
              >
                ×
              </button>
            )}
          </div>
        </div>
        <div className="language-list">
          {allLanguages.length === 0 ? (
            <div className="language-empty">
              <EarthIcon />
              <div className='maintext'>{t('10603', 'No languages found')}</div>
              <div className='desctext'>{t('10604', 'Please check your spelling or clear your search to view all available languages')}.</div>
              <button
                className="clear-btn"
                onClick={() => setSearch('')}
                aria-label="Clear search"
              >
                <div className='repeat_button'>
                  <RepeatIcon />
                  {t('6016', 'Clear')}
                </div>
              </button>
            </div>
          ) : (
            allLanguages.map((lang) => (
              <div
                key={lang.languageId}
                className="language-item"
                onClick={() => onSelect(lang.languageId)}
              >
                <span>{lang.name}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}

export default LanguagePickerModal
